import {useEffect, useState} from "react";

export default function Sandbox () {

    const [cardList, setCardList ]  = useState([
        {id: 1, order: 1, text: 'Apple'},
        {id: 2, order: 2, text: 'Orange'},
        {id: 3, order: 3, text: 'Kiwi'},
        {id: 4, order: 4, text: 'Mandarin'},
        {id: 5, order: 5, text: 'Coconut'},
    ])

    const [currentCard, setCurrentCard] = useState<any>(null)

    let cardStyles: any = {
        width: '150px',
        height: '200px',
        borderRadius: '12px',
        border: '3px solid',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '20px',
        cursor: 'grab',
    }

    function dragStartHandler(e: any, card: any) {
        // console.log('drag: ', card)
        setCurrentCard(card)

    }

    function dragEndHandler(e: any) {
        e.target.style.background = 'white'
    }

    function dragOverHandler(e: any) {
        e.preventDefault()
        e.target.style.background = 'lightgray'
    }

    function dropHandler(e: any, card: any) {
        e.preventDefault()
        // console.log('moving card:', currentCard)
        // console.log('bottom card: ', card)


        let currentCardIndex = cardList.indexOf(currentCard)
        let bottomCardIndex = cardList.indexOf(card)
        let before = cardList.slice(0, bottomCardIndex)
        let after = cardList.slice(bottomCardIndex)

        if (currentCardIndex < bottomCardIndex) {
            before.splice(before.indexOf(currentCard), 1)
            after.splice(after.indexOf(card), 1)
            before.push(card)
            after.unshift(currentCard)
        } else {
            after.splice(after.indexOf(currentCard), 1)
            after.unshift(currentCard)
        }
        setCardList(before.concat(after))
        e.target.style.background = 'white'
    }



    let cardElements = cardList.map( card =>

            <div
                key={card.id}
                onDragStart={(e) => dragStartHandler(e, card)}

                onDragLeave={(e) => dragEndHandler(e)}
                onDragEnd={(e) => dragEndHandler(e)}

                onDragOver={(e) => dragOverHandler(e)}
                onDrop={(e) => dropHandler(e, card)}

                style={cardStyles}
                draggable={true}
            >
                {card.text}

            </div>

        )

    return (
        <div style={{display: 'flex'}} >
            {cardElements}
        </div>
    )
}